// third-party
import { combineReducers } from "redux";
import menu from "./menu";
import search from "./search";
import users from "./users";
import { userApi } from "services/user-service";
import { partnerPlanApi } from "services/partner-plan-service.js";
import { authApi } from "services/auth-service";
import { accountApi } from "services/account-service";
import { campaignsApi } from "services/campaign-service";
import account from "./account";
import { planApi } from "services/userPlan-service";
import { leadUsageApi } from "services/lead-usage-service";

const reducers = combineReducers({
  menu,
  [planApi.reducerPath]: planApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [partnerPlanApi.reducerPath]: partnerPlanApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [accountApi.reducerPath]: accountApi.reducer,
  [campaignsApi.reducerPath]: campaignsApi.reducer,
  [leadUsageApi.reducerPath]: leadUsageApi.reducer,
  search,
  account,
  users,
});

export default reducers;
